module.exports = __webpack_public_path__ + "img/iran-logo-icon.7da288c0.png";